<template>
  <div class="progress-bar-legend">
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl1">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_1_svg.svg"
        alt="1lvl"
      />
      <span class="progres-bar-legend-item-range">0-800</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_2_svg.svg"
        alt="2lvl"
      />
      <span class="progres-bar-legend-item-range">801-950</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_3_svg.svg"
        alt="3lvl"
      />
      <span class="progres-bar-legend-item-range">951-1100</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_4_svg.svg"
        alt="4lvl"
      />
      <span class="progres-bar-legend-item-range">1101-1250</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_5_svg.svg"
        alt="5lvl"
      />
      <span class="progres-bar-legend-item-range">1251-1400</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_6_svg.svg"
        alt="6lvl"
      />
      <span class="progres-bar-legend-item-range">1401-1550</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_7_svg.svg"
        alt="7lvl"
      />
      <span class="progres-bar-legend-item-range">1551-1700</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_8_svg.svg"
        alt="8lvl"
      />
      <span class="progres-bar-legend-item-range">1701-1850</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_9_svg.svg"
        alt="9lvl"
      />
      <span class="progres-bar-legend-item-range">1851-2000</span>
    </div>
    <div class="separator"></div>
    <div class="progress-bar-legend-item progress-bar-legend-item-lvl2-10">
      <img
        class="progress-bar-legend-item-lvl"
        src="../assets/img/lvls/skill_level_10_svg.svg"
        alt="10lvl"
      />
      <span class="progres-bar-legend-item-range">2001+</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "EloBarLegend"
};
</script>
